import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import IconSuccess from "../img/icons/icon-check.svg";
import toast, { Toaster } from 'react-hot-toast';
import { Base64 } from 'js-base64';
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";

export default function Changepw(prop) {
    let navigate = useNavigate();
    let {slug} = useParams();

    let [passwordInputType, setPasswordInputType] = React.useState('password');
    let [confirmPasswordInputType, setConfirmPasswordInputType] = React.useState('password');
    let [datetime, setDatetime] = React.useState(null);
    let [email, setEmail] = React.useState(null);
    let [code, setCode] = React.useState(null);

    let refPassword = React.useRef();
    let refConfirmPassword = React.useRef();

    React.useEffect(() => {
        document.title = 'เปลี่ยนรหัสผ่าน | NCSA';

        if(prop.member) {
            navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
        }

        if(slug) {
            let base64Decode = Base64.decode(slug);
            let jsonDecode = JSON.parse(base64Decode);
            if(jsonDecode.email && jsonDecode.datetime && jsonDecode.code) {
                setEmail(jsonDecode.email);
                setDatetime(jsonDecode.datetime);
                setCode(jsonDecode.code);
            }
            else {
                //navigate((prop.lang === 'en' ? '/en':'/') + 'login');
            }
        }
        else {
            navigate((prop.lang === 'en' ? '/en':'/') + 'login');
        }
    }, []);

    const onSubmit = async () => {
        let password = refPassword.current.value;
        let confirmPassword = refConfirmPassword.current.value;

        if(password === '' || !Utils.strengthPassword.test(password)) {
            toast.error(prop.lang === 'en' ? 'Please enter your password according to the specified format':'กรุณาระบุ รหัสผ่าน ตามรูปแบบที่กำหนดไว้');
            refPassword.current.focus();
        }
        else if(confirmPassword === '' || confirmPassword !== password) {
            toast.error(prop.lang === 'en' ? 'Please provide the same password':'กรุณาระบุ รหัสผ่านให้ตรงกัน');
            refConfirmPassword.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการเปลี่ยนรหัสผ่าน ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                email: email,
                                password: password,
                                datetime: datetime,
                                code: code,
                                updatePasswordAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updatePassword(param);
                            if(result) {
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'Successfully changed the password':'เปลี่ยนรหัสผ่านใหม่เรียบร้อย');
                                    setTimeout(function () {
                                        navigate((prop.lang === 'en' ? '/en':'/') + 'login');
                                    }, 1500);
                                }
                                else if(result.status === 'code') {
                                    toast.error(prop.lang === 'en' ? 'Email codes do not match':'รหัสโค้ดจากอีเมลไม่ตรงกัน');
                                }
                                else if(result.status === 'date') {
                                    toast.error(prop.lang === 'en' ? 'The code from the email has expired':'รหัสโค้ดจากอีเมลหมดอายุแล้ว');
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, your password cannot be changed. Please check the link again':'ขออภัย ไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาตรวจสอบลิ้งค์อีกครั้ง');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updatePassword(param) {
        const response = await fetch(Config.apiUrl +'/member/updatePassword', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    let [validPassword, setValidPassword] = React.useState(true);
    const onKeyUpPassword = () => {
        if(refPassword.current.value) {
            let valid = Utils.strengthPassword.test(refPassword.current.value);
            setValidPassword(valid);
        }
        else {
            setValidPassword(true);
        }
    };

    return (
        <>
            <div className="section">
                <div className="container py-2">
                    <div className="card-infos has-shadow-black w-1020">

                        <div className="hgroup text-center" data-aos="fade-in">
                            <h2 className="my-2">{prop.lang === 'en' ? 'Change Password':'เปลี่ยนรหัสผ่าน'}</h2>
                        </div>

                        <div className="boxed" data-aos="fade-in">
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Password':'รหัสผ่าน'} <span className="star">*</span></h6>
                                        <div className="group">
                                            <span className="icons icon-eye right" onClick={e => {setPasswordInputType(passwordInputType === 'password' ? 'text':'password')}}></span>
                                            <input type={passwordInputType} className="form-control" ref={refPassword} maxLength={20} onKeyUp={onKeyUpPassword} />
                                        </div>
                                        <div className={"alert alert-xs mt-2 mb-0 " + (refPassword.current?.value ? (!validPassword ? 'alert-danger':'alert-success') : 'alert-warning')}>
                                            {Utils.passwordAlert(prop.lang)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Confirm Password':'ยืนยันรหัสผ่าน'} <span className="star">*</span></h6>
                                        <div className="group">
                                            <span className="icons icon-eye right" onClick={e => {setConfirmPasswordInputType(confirmPasswordInputType === 'password' ? 'text':'password')}}></span>
                                            <input type={confirmPasswordInputType} className="form-control" ref={refConfirmPassword} maxLength={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 mt-0 mb-4">
                                <button className="btn btn-primary w-100" type="button" onClick={onSubmit}>
                                    {prop.lang === 'en' ? 'Confirm':'ยืนยัน'}
                                </button>
                            </div>

                            <div className="col-12 my-sm-4">
                                <div className="form-group text-center text-black"><NavLink to={prop.lang === 'en' ? '/en/login':'/login'} className="link-underline">{prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'}</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 